import React, { PropsWithChildren } from 'react'
import * as S from './styles';
interface IKOGSectionProps {
  title?: React.ReactNode;
}
function KOGSection({
  title,
  children
}: PropsWithChildren<IKOGSectionProps>) {
  return (
    <S.Container>
      <S.HeaderSection>
        {title && <S.TitleSection>{title}</S.TitleSection>}
      </S.HeaderSection>
      {children}
    </S.Container>
  )
}

export default KOGSection